import { Text } from "@alpacahq/ui/old";

import { Asterisk } from "~/v2/components/form";
import { Radio } from "./Radio";

export const RadiosInput = ({
  id,
  label,
  options,
  value,
  onSelect,
  errorMessage,
  isRequired = true,
}: {
  id: string;
  label: string;
  options: { label: string; value: string }[];
  value: string;
  onSelect: (value: string) => void;
  errorMessage?: string;
  isRequired?: boolean;
}) => {
  const handleSelect = (value: string) => () => {
    onSelect(value);
  };

  return (
    <div className="pb-4">
      <Text className="max-w-xl pb-4 font-medium leading-5">
        {label} <Asterisk required={isRequired} />
        {errorMessage && (
          <span className="ml-1 font-normal text-base text-red-500">
            {errorMessage}
          </span>
        )}
      </Text>
      {options.map((option) => (
        <div key={option.value} className="mb-2">
          <Radio
            id={`${id}_${option.value}`}
            label={option.label}
            value={option.value}
            isChecked={value === option.value}
            onClick={handleSelect(option.value)}
          />
        </div>
      ))}
    </div>
  );
};
